import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "grid",
  "use": "grid-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"grid\">\n  <path fill-rule=\"evenodd\" d=\"M263,193h4v4h-4v-4Zm12,0h4v4h-4v-4Zm-6,0h4v4h-4v-4Zm-6,6h4v4h-4v-4Zm12,0h4v4h-4v-4Zm-6,0h4v4h-4v-4Zm-6,6h4v4h-4v-4Zm12,0h4v4h-4v-4Zm-6,0h4v4h-4v-4Z\" transform=\"translate(-262.5 -192.5)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/grid.svg
// module id = null
// module chunks = 